module.exports = __webpack_public_path__ + "img/bread_slices.0956c32d.jpg";